const slideLength = document.querySelectorAll('.swiper-wrapper .swiper-slide').length
if (slideLength > 1) {
const fv_slider = new Swiper(".p_category_mvThumbnailSlider", {
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  speed: 1000,
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  pagination: { el: ".swiper-pagination", clickable: true },
  breakpoints: { 768: { slidesPerView: 1, spaceBetween: 20 } },
});
  }
function headerHeightCssCustomProperty() {
  const header = document.querySelector(".js_header"),
    headerHeight = header.clientHeight;
  return (
    document.documentElement.style.setProperty(
      "--header-height",
      headerHeight + "px"
    ),
    headerHeight
  );
}


   const b_category_tast_itemThumbnailSlider = new Swiper(".b_category_tast_itemThumbnailSlider", {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    speed: 500,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      768: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
  });


  document.addEventListener('DOMContentLoaded', function() {
    // .price-item--regular クラスを持つすべての要素を取得

setTimeout(function() {
        // .price-item--regular クラスを持つすべての要素を取得
        const priceItems = document.querySelectorAll('.price-item--regular');

        // 各要素のテキストを置換
        priceItems.forEach(function(item) {
            item.textContent = item.textContent.replace('から', '〜');
        });


    }, 2000);

});
